<template>
  <div v-if="renderDescription">
    <template v-if="description || editing">
      <div>
        <b-form-textarea
          v-if="$root.isOwner && editing"
          ref="description"
          id="description"
          @keydown.ctrl.enter.exact.prevent="update"
          @keydown.esc="editing = false"
          @keydown="(e) => e.stopPropagation()"
          @blur="update"
          :value="description"
          max-rows="6"
          no-resize
        ></b-form-textarea>
        <div class="description-content" ref="descriptionContent" :class="{ expanded: showMore }" @click="edit" v-show="!editing">
          <vue-markdown :html="false" :source="description"></vue-markdown>
        </div>
        <a href="#" id="show-more" @click.prevent="toggleFullDescription" v-show="!editing && (!descriptionFits || showMore != null)">
          {{ showMore ? 'View less' : 'View more' }}
          <img src="@img/icons-toggle-close.svg" v-show="showMore" />
          <img src="@img/icons-toggle-open.svg" v-show="!showMore" />
        </a>
      </div>
    </template>
    <template v-else-if="$root.isOwner">
      <a
        v-if="!$root.showSimplifiedInterface"
        id="add-description"
        href="#"
        @click.prevent="edit">
        Add description
        <img src="@img/icons-add.svg" />
      </a>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import track from '@/src/tracking';
import VueMarkdown from '@adapttive/vue-markdown';


export default {
  components: { VueMarkdown },
  data: function(){
    return {
      editing: false,
      showMore: null,
      descriptionFits: false
    }
  },
  computed: {
    ...mapState(['item']),
    description: function(){
      return this.$root.preview.item.description || this.item.attributes.description || "";
    },
    renderDescription: function(){
      if(this.$root.isOwner) return true
      if(!this.item.attributes.description) return false

      return true;
    }
  },
  methods: {
    toggleFullDescription: function(){
      this.showMore = !this.showMore
    },
    update: function(){
      const vm = this;
      let description = this.$refs.description.$refs.input.value.trim();
      if(description.length == 0){ description = null; }

      if(description != this.item.attributes.description){
        vm.$store.dispatch('updateItem', { itemId: this.item.id, body: { description }})
        .then(() => {
          // This updates the preview descrpition used in templates, so the actual saved description is used instead of the preview.
          if(vm.$root.preview.item.description){
            vm.$root.preview.item.description = description;
          }
          vm.$root.toastSuccess('Description updated');
          track('viewer_description_changed ', { description })
          vm.editing = false;
        })
        .catch(() => vm.$root.toastError('Could not update description, please try again.'));
      } else {
        vm.editing = false;
      }
    },
    edit: function(){
      const vm = this;
      if(!vm.$root.isOwner) { return; }

      vm.editing = true;
      vm.$nextTick(function(){
        vm.$refs.description.focus();
      })
    }
  },
  watch: {
    description: {
      immediate: true,
      handler: function(newVal, oldVal){
        const vm = this;
        if(newVal){
          vm.$nextTick(function(){
            const observer = new ResizeObserver((entries) => {
              const domDescription = entries[0].target;
              if(domDescription.scrollHeight > domDescription.offsetHeight) {
                vm.descriptionFits = false;
              }else {
                vm.descriptionFits = true;
              }
            });

            observer.observe(vm.$refs.descriptionContent)
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/packs/colors.scss';

  #add-description, #show-more {
    margin: 0;
    cursor: pointer;
    color: $viewer-blue;
    display: flex;
    align-items: center;
    font-size: .75rem;

    img {
      margin-left: 5px;
      margin-top: 1px;
    }
  }

  #show-more {
    margin-top: 10px;
  }

  h5{
    font-size: 1rem;
    color: $dark-gray;
    font-weight: bold;
  }

  textarea {
    border: 0;
    outline: 0;
    padding: 10px;
    width: 100%;
    background: white;
    resize: none;
    overflow-y: auto !important;

    &:focus {
      box-shadow: none;
    }
  }

  textarea, .description-content {
    margin: 0;
    font-family: SFpro;
    font-size: .75rem;
  }

  .description-content {
    color: $dark-gray;
    font-size: .75rem;
    max-width: 90%;

    // this is for the ellipsis effect on description content
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;

    &.expanded {
      -webkit-line-clamp: unset;
    }

    div p:last-child {
      margin-bottom: 0;
    }
  }

  >>> .description-content div p:last-child {
    margin-bottom: 0;
  }


</style>
